<div class="w-100 h-100 login-grid" [ngStyle]="{'background-image': bgImg}">
  <div class="login-image">
    <div>
      <img [src]="logoImg" alt="logo">
    </div>
  </div>
  <div class="login-card">
    <div class="login-card-center">
      <div class="login-top">
        <mat-icon class="user-login-icn" color="accent">
          account_circle
        </mat-icon>
        <div class="welcome-message">
          {{"login.welcome_message" | translate }}
        </div>
      </div>
      <form #loginForm="ngForm" class="d-flex flex-column gap-3" (keyup.enter)="onLogin(loginForm);$event.stopPropagation();">
        <!-- SEZIONE LOGIN STANDARD -->
        <ng-container *ngIf="isAuthEnabled('standard')">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'login.username' | translate }}</mat-label>
            <input matInput [placeholder]="'login.username' | translate" ngModel name="username" required>
          </mat-form-field>

          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'login.password' | translate }}</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'"
              [placeholder]="'login.password' | translate" ngModel name="password" required>
            <button mat-icon-button matSuffix (click)="showHide($event)" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="!hide">
              <mat-icon color="accent">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>

          <div *ngIf="loginError">
            <span class="badge badge-danger"> {{loginError}} </span>
          </div>

          <div class="d-flex flex-column gap-2">
            <button type="submit" class="w-100" mat-raised-button color="primary" (click)="onLogin(loginForm)">
              {{ 'login.login' | translate | uppercase}}
            </button>

            <button (click)="passwordrecovery()" mat-flat-button class="recover-pwd-btn w-100">
              {{ 'login.recovery_pwd' | translate }}
            </button>
          </div>
        </ng-container>

        <!-- SEZIONE LOGIN SSO -->
        <ng-container *ngIf="hasSsoLogin">
          <div *ngIf="isAuthEnabled('standard')" class="sso-divider">
            <span class="sso-divider__label">{{ 'login.sso_login' | translate }}</span>
          </div>
          <div *ngIf="!isAuthEnabled('standard')" class="sso-title">{{ 'login.sso_login' | translate }}</div>

          <div class="d-flex flex-column gap-2">
            <button *ngIf="isAuthEnabled('entraid')" type="button" class="w-100" mat-stroked-button (click)="loginWithEntra()">
              <img src="assets/icons/microsoft-logo.svg" alt="Microsoft" width="18" height="18" style="vertical-align:middle; margin-right:8px;">
              {{ 'login.login_with_microsoft' | translate }}
            </button>
          </div>
        </ng-container>

      </form>
    </div>
  </div>
</div>
